<template>
	<b-container class="pt-4">
		<header>
			<b-link to="/blog"><fa :icon="fasChevronLeft" />&nbsp;Tilbage til blog-oversigt</b-link>
			<h1 v-html="post.title"></h1>
			<p>
				<small><post-timestamp :post="post" /></small>
			</p>
		</header>

		<hr>
		<b-row style="align-items: start;">
			<b-col cols="12" md="8" class="border-right hide-border-right-md">
				<article>
					<nuxt-content :document="post" />
				</article>
			</b-col>
			<b-col cols="12" md="4" class="d-none d-md-block" style="position: sticky; top: 70px;">
				<p v-for="el of post.toc" :key="el.id" :class="{small: el.depth == 3, 'ml-3': el.depth == 3}" :style="{'margin-top': el.depth==3?'-.8em':''}">
					<b-link @click="go_to_header(el.id)">{{ el.text }}</b-link>
				</p>
			</b-col>
		</b-row>
		<hr>
		<div class="d-flex justify-content-between">
			<b-button v-if="prev" :to="prev.path" left><fa :icon="fasChevronLeft" />&nbsp;Ældre</b-button>
			<b-button v-if="next" :to="next.path" right>Nyere&nbsp;<fa :icon="fasChevronRight" /></b-button>
		</div>
	</b-container>
</template>

<script>
import {
	BContainer,
	BLink,
	BRow,
	BCol,
	BButton,
	BImg,
} from "bootstrap-vue";

import PostTimestamp from "~/components/PostTimestamp.vue";
import {fasChevronLeft, fasChevronRight} from "!!fa-icon-loader!~/assets/@fortawesome/fontawesome-pro/metadata/icons.json";

export default {
	components: {
		BContainer,
		BLink,
		BRow,
		BCol,
		BButton,
		BImg,

		PostTimestamp,
		LazyImage: ()=>import("~/components/LazyImage.vue")
	},
	data() {
		return {
			post: {},
			prev: false,
			next: false,
		}
	},
	computed: {
		fasChevronLeft() {return fasChevronLeft},
		fasChevronRight() {return fasChevronRight},
	},

	async asyncData ({$content, params}) {
		let post = await $content(`blog/${params.pathMatch}`, {deep:true}).fetch()

		post = JSON.parse(JSON.stringify(post).replace(/~\/assets\/blog\/([A-z0-9%./\-]+)/, (asset) => {
			asset = asset.match(/~\/assets\/blog\/([A-z0-9%./\-]+)/)[1];
			return require('../../assets/blog/' + asset);
		}))

		const [prev, next] = await $content("blog", {deep: true})
				.only(['title', 'path', 'createdAt'])
				.sortBy("createdAt", "asc")
				.surround(post.path)
				.fetch();


		return {
			post,
			prev,
			next,
		}
	},
	head() {
		return {
			title: this.post.title,
			titleTemplate: 'SkvizBiz - %s',
		}
	},
	methods: {
		scroll_to_element_id(id) {
			let el = document.getElementById(id);
				console.log("scroll to " + id);
			if (el) {
				window.scrollTo({top: el.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth'});
			}
		},

		go_to_header(id) {
			history.pushState({}, "", `#focus_${id}`);
			this.scroll_to_element_id(id);
		},
	},
	mounted() {
		this.$nextTick(()=>{
			if (this.$route.hash) {
				this.scroll_to_element_id(decodeURIComponent(this.$route.hash.substr(7)));
			}
		})
	},
}
</script>

<style lang="scss">
	article {
		font-size: 1.1em;
		line-height: 1.8em;

		p + h2 {
			margin-top: 1em;
		}

		h1,
		h2,
		h3,
		h4 {
			margin-top: .7em;
		}
		ul + p {
			margin-top: 1.5rem;
		}
		li {
			margin-bottom: .4em;
			li {
				margin-bottom: 0;
			}
		}
		q {
			background: rgba(52, 58, 64, 0.15);
		}
		q::before,
		q::after {
			content: none;
		}
	}
	.footnotes {
		font-size: .8em;
		line-height: normal;

		> ol {
			padding-left: 1.5rem;
		}

		.footnote-backref {
			display: none;
		}
	}
	li > ul {
		margin-bottom: .5rem;
	}
	p + ul {
		margin-top: -.5rem;
	}
	@media (max-width: 767px) {		
		.hide-border-right-md {
			border-right: none !important;
		}
	}

	.badge-tip {
		color: #fff;
		background-color: #17a2b8;
		
		translate: 0 -0.1em;
		&::before {
			content: "";
			background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='#fff' d='M17.66 11.2c-.23-.3-.51-.56-.77-.82c-.67-.6-1.43-1.03-2.07-1.66C13.33 7.26 13 4.85 13.95 3c-.95.23-1.78.75-2.49 1.32c-2.59 2.08-3.61 5.75-2.39 8.9c.04.1.08.2.08.33c0 .22-.15.42-.35.5c-.23.1-.47.04-.66-.12a.6.6 0 0 1-.14-.17c-1.13-1.43-1.31-3.48-.55-5.12C5.78 10 4.87 12.3 5 14.47c.06.5.12 1 .29 1.5c.14.6.41 1.2.71 1.73c1.08 1.73 2.95 2.97 4.96 3.22c2.14.27 4.43-.12 6.07-1.6c1.83-1.66 2.47-4.32 1.53-6.6l-.13-.26c-.21-.46-.77-1.26-.77-1.26m-3.16 6.3c-.28.24-.74.5-1.1.6c-1.12.4-2.24-.16-2.9-.82c1.19-.28 1.9-1.16 2.11-2.05c.17-.8-.15-1.46-.28-2.23c-.12-.74-.1-1.37.17-2.06c.19.38.39.76.63 1.06c.77 1 1.98 1.44 2.24 2.8c.04.14.06.28.06.43c.03.82-.33 1.72-.93 2.27'/%3E%3C/svg%3E");
			background-repeat: no-repeat;
			background-size: contain;
			height: 1em;
			margin-bottom: -.2em;
			width: 1em;
			display: inline-block;
			translate: -1px -1px;
		}
	}


	.has_video_icon {
		.video_icon {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%) scale(1);
			color: #ff0000;
			filter: drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 0.05em) drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 0.1em);
			transition: all .1s ease-in-out;
		}
		.shadowed {
			box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
			transition: all .1s ease-in-out;
		}

		&:hover {
			.video_icon {
				transform: translateX(-50%) translateY(-50%) scale(1.1);
				filter: drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 0.05em) drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 0.1em);
			}
			.shadowed {
				box-shadow: 0 .5rem 1rem rgba(0,0,0,.25);
			}
		}

	}
</style>